import { useTranslate } from '@tolgee/react';
import React, { useEffect, useRef, useState } from 'react';
import { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAdditionalPostText,
  setPostText
} from '../../../../redux/slices/externalContent/externalContent';
import { externalContentRootState } from '../../../../pages/externalContent';
import { ADDITIONALINFO, MAINTEXT } from '../../utils/constant';
import EmojiPicker from '../../../communication/messages/emojiPicker/empjiPicker';
import { QUILL_API_ACTION_ADD_EMOJI } from '../../../lomavisCreator/components/creatorTextEditor/config';

interface Props {
  TextField: string;
}

const QuillEditor: React.FC<Props> = ({ TextField }) => {
  const dispatch = useDispatch();
  const quillRef = useRef(null);
  const [quillEditor, setQuillEditor] = useState<any>(null);

  useEffect(() => {
    const modules = {
      toolbar: false
    };
    const editor = new Quill(quillRef.current, {
      theme: 'snow',
      readOnly: false,
      modules
    });
    setQuillEditor(editor);

    // Add event listener for text change
    editor.on('text-change', () => {
      const content = editor?.getContents();

      if (TextField === MAINTEXT) {
        dispatch(setPostText(content));
      } else if (TextField === ADDITIONALINFO) {
        dispatch(setAdditionalPostText(content));
      }
    });
  }, [dispatch]);

  const addEmoji = (emoji: string): void => {
    quillEditor.insertText(
      quillEditor.getSelection(true).index,
      emoji,
      QUILL_API_ACTION_ADD_EMOJI
    );
  };

  return (
    <div>
      <div
        className="custom-editor overflow-visible w-100 border rounded ql-container h-100"
        ref={quillRef}
        style={{
          minHeight: 150
        }}
      ></div>
      <EmojiPicker addEmoji={addEmoji} />
    </div>
  );
};

export default QuillEditor;
